define([
    'underscore',
    'customerEdge/quoteandbind/common/models/Person',
    'integration/quoteandbind/PolicyLineExtensionConfiguration',
    'origEdge/quoteandbind/common/models/Submission',
    'edge/platform/basler/util/MFPPartnerUtil',
], (_, Person, PolicyLineExtensionConfiguration, OOTBSubmission, MFPPartnerUtil) => {

    Submission.prototype = Object.create(OOTBSubmission.prototype);
    Submission.prototype.constructor = Submission;
    function Submission(data, productCode, subproductInputParam, empMode = false) {

        // PROCESS
        if (data) {

            data.persons = [];

            if (data.draftData) {
                data.draftData.accountHolder.contact = this._forcePerson(data, data.draftData.accountHolder.contact || {}); // eslint-disable-line no-underscore-dangle
                if (data.draftData.accountHolder.contact) {
                    data.draftData.accountHolder.contact.accountHolder = true;
                    data.draftData.accountHolder.contact.primaryAddress = data.draftData.policyAddress;
                }
            }
            _.extend(this, data);
        } else {

            this.draftData = {
                accountHolder: {
                    contact: {
                        tempID: this.nextId(),
                        accountHolder: true,
                    },
                },
                policyAddress: {},
                periodStartDate: new Date(),
                productCode,
                subproductInputParam,
                employeeMode: (empMode === 'true' || empMode === true), //NOSONAR accepting and string and boolean
                paymentMethod: undefined,
                lobs: {},
            };


            this.draftData.partnerDetails = MFPPartnerUtil.getInitializedPartnerDetails(
                productCode,
                subproductInputParam,
                this.draftData.employeeMode
            );

            this.draftData.accountHolder.contact.primaryAddress = this.draftData.policyAddress;
            this.persons = [];
            this.persons.push(this.draftData.accountHolder.contact);
        }
        if (data && data.draftData) {
            this.draftData.questionSetNames = [];
        }

        PolicyLineExtensionConfiguration.mixinLobDraftDataExtensions(this);
    }

    Submission.prototype._forcePerson = function (submission, person) { // eslint-disable-line no-underscore-dangle
        let p = person.publicID ? _.findWhere(submission.persons, {publicID: person.publicID}) : null;
        if (!p) {
            p = new Person(person);
            p.tempID = this.nextId();
            submission.persons.push(p);
        }
        return p;
    };

    // PERSON
    Submission.prototype.createPerson = function (options) {
        const person = new Person({
            tempID: this.nextId(),
        });

        if (options) {
            Object
                .keys(options)
                .filter(key => typeof options[key] !== 'function')
                .forEach((key) => {
                    person[key] = options[key];
                });
        }

        this.persons.push(person);
        return person;
    };

    Submission.prototype.createOrUpdatePerson = function (person) {
        let newPerson = _.findWhere(this.persons, {publicID: person.publicID});

        if (!newPerson) {
            newPerson = this.createPerson(person);
        } else {
            newPerson = person;
        }

        return newPerson;
    };

    /**
     * Sets the given person as the only person in this submission.
     * No checks for PublicID or TempIDs will be done.
     * @param person
     */
    Submission.prototype.removeAnyOtherPerson = function (person) {
        this.persons = [person];
    };

    return Submission;
});



// WEBPACK FOOTER //
// ./app/customer/js/src/edge/quoteandbind/common/models/Submission.js